import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactoryResolver, Compiler, ComponentRef, ComponentFactory, NgModule, ModuleWithComponentFactories, Injector, ElementRef } from '@angular/core';
@Component({
  selector: 'app-customrendered',
  templateUrl: './customrendered.component.html',
  styleUrls: ['../rendered.component.scss', './customrendered.component.scss']
})
export class CustomrenderedComponent implements OnInit {

  @Input() item;
  @Input() edit;
  ngOnInit() {
    console.log(this.item);
   /* if (this.item.html)
      this.compileTemplate();*/
  }
  @ViewChild('container', { static: true }) comp: ElementRef;
  genHTML(html) {
    if (html) {
      var matches = html.match(/{{[^}]+}}/g);
      if (matches && matches.length > 0) {
        matches.forEach(match => {
          var param = match.replace(/{{/, "").replace(/}}/, "");
          var m = new RegExp(match);
          html = html.replace(m, this.item[param] || "<span style='color:red;'>Missing value for " + param + "</span>");
        })
      }
    } else {
      html = "";
    }
    console.log(html);
    return html;
  }

  calcContents() {


    console.log(this.comp.nativeElement);
  }

  genTemplate(html) {
    if (html) {
      var matches = html.match(/{{[^}]+}}/g);
      if (matches && matches.length > 0) {
        matches.forEach(match => {
          var param = match.replace(/{{/, "").replace(/}}/, "");
          var m = new RegExp(match);
          html = html.replace(m, "{{item." + param + "}}" || "<span style='color:red;'>Missing value for " + param + "</span>");
        })
      }
      console.log(html);
    }
    return html;
  }

  template: string = '<div>\nHello, {{name}}\n</div>';
  /*
  @ViewChild('container', { read: ViewContainerRef
  })
  container: ViewContainerRef;

  private componentRef: ComponentRef<{}>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private compiler: Compiler
  ) {
  }

  compileTemplate() {
    var html = this.genTemplate(this.item.html) 
    let metadata = {
      selector: `runtime-component-sample`,
      template: html
    };

    let factory = this.createComponentFactorySync(this.compiler, metadata, null, this.item);

    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
    this.componentRef = this.container.createComponent(factory);
  }

  private createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any, data): ComponentFactory<any> {
    var $this = this;
    const cmpClass = componentClass || class RuntimeComponent { item = data };
    const decoratedCmp = Component(metadata)(cmpClass);
    
 
    @NgModule({ imports: [CommonModule, SharedModule], declarations: [decoratedCmp], entryComponents:[] })
    class RuntimeComponentModule { }

    let module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(RuntimeComponentModule);
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
  }
  */
}
